import { blue, darkOrange, warmTint } from '@/theme/colors'
import { fontDisplay } from '@/theme/fonts'
import { breakpoints, radii } from '@/theme/tokens'
import styled from 'styled-components'

export const HeaderRow = styled.div`
	display: flex;
	align-items: center;
	gap: 11px;
	margin-bottom: 2px;
`

export const IconChip = styled.span`
	width: 28px;
	height: 28px;
	border-radius: ${radii.pill};
	background: ${warmTint};
	color: ${darkOrange};
	display: inline-flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
`

export const Label = styled.span`
	font-family: ${fontDisplay};
	font-weight: 700;
	font-size: 18px;
	letter-spacing: -0.01em;
	color: ${darkOrange};

	@media (max-width: ${breakpoints.phone}px) {
		font-size: 17px;
	}
`

/**
 * Right-aligned hover arrow. Hidden at rest; the parent tile's `:hover` fades and
 * slides it in (see `BentoTile.styles.ts`, which references this component).
 */
export const TileArrow = styled.span`
	margin-left: auto;
	color: ${blue};
	display: inline-flex;
	opacity: 0;
	transform: translateX(-4px);
	transition:
		opacity 0.2s ease-out,
		transform 0.2s ease-out;
`
